import React, { useContext } from 'react';
import { ActionBar } from 'common';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import * as R from 'ramda';
import Terminals from '../../components/TerminalsAccordion';
import LoadingControlNumbers from './LoadingControlNumbers';
import { ITN_AUTH_TYPES, ITN_LENGTH, ITN_REGEX } from './LoadingControlDetails';
import { CreateCustomerAuthContext } from '../Create';
import CustomerInformationAccordion from '../../components/CustomerInformationAccordion';
import Products from '../../components/ProductsAccordion';
import TitleBar from '../TitleBarConnector';

const stackSTyles = {
  /* eslint-disable sort-keys-fix/sort-keys-fix */
  mx: 'auto',
  pt: { xs: 6, lg: 9 },
  pb: 10,
  width: { xs: 1, lg: 760 },
};

const DestinationsControlNumbers = () => {
  const { info } = useContext(CreateCustomerAuthContext);
  const { authorizationType, controlNumbers = [], controlType, products, terminals } = info;

  // Checks for valid length ITNs, but only if the auth type selected allows for ITNs and ITN is toggled on
  const validItns =
    !ITN_AUTH_TYPES.some(type => type === authorizationType) ||
    !controlNumbers.some(
      ({ itn }) => !R.isNil(itn) && (itn.length !== ITN_LENGTH || !itn.match(ITN_REGEX))
    );

  return (
    <>
      <TitleBar handleClose={R.identity} />
      <Stack spacing={2} sx={stackSTyles}>
        <CustomerInformationAccordion customerAuthorization={{ ...info }} />
        <Box>
          <Terminals controlType={controlType} terminals={terminals} />
        </Box>
        <Box>
          <Products authorizationType={authorizationType} products={products} />
        </Box>
        <LoadingControlNumbers />
      </Stack>
      <ActionBar
        backLink="../terminals-products"
        continueLink="../carriers"
        disableAction={R.isEmpty(controlNumbers) || !validItns}
      />
    </>
  );
};

export default DestinationsControlNumbers;
